import axios from 'axios';

const idkitApi = axios.create({
  baseURL: process.env.VUE_APP_IDKIT_URL_AUTH,
});

export default {
  validateUserSession(email, state, orderId) {
    return idkitApi
      .get('/callback', {
        params: {
          email,
          state,
          redirectURL: `${window.location.origin}/auth?orderId=${orderId}`,
        },
      })
      .then((res) => {
        if (!res.data) throw res;
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  getIDKitSessionData(state) {
    return idkitApi
      .get(`${process.env.VUE_APP_IDKIT_URL_AUTH}/auth`, {
        params: {
          state,
        },
      })
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
  updateSessionToken(state) {
    return idkitApi
      .get(`${process.env.VUE_APP_IDKIT_URL_AUTH}/refreshTokens`, {
        params: {
          state,
        },
      })
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
  logout(state) {
    return axios
      .get(`${process.env.VUE_APP_IDKIT_URL_AUTH}/logout`, {
        params: {
          state,
          redirectURL: `${window.location.origin}/auth`,
        },
      })
      .then((res) => {
        if (!res.data.success) throw res.data.message;

        return res.data.success;
      })
      .catch((err) => {
        throw err;
      });
  },
};
